import React from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

import SliderImg1 from "../../assets/img/Mimaweb.png";
import SliderImg2 from "../../assets/img/Mimaweb-1.png";
import SliderImg3 from "../../assets/img/Mimaweb-2.png";

import styles from "../../assets/styles/pageComponents/LeftSideSlider.module.scss";

const LeftSideSlider = () => {
  return (
    <div className={styles.slider}>
      <Carousel
        autoPlay
        infiniteLoop
        interval={5000}
        showStatus={false}
        showThumbs={false}
        showArrows={false}
        animationHandler="fade"
        swipeable={false}
        transitionTime={500}
      >
        <div>
          <img src={SliderImg1} className={styles.slider__img} />
        </div>
        <div>
          <img src={SliderImg2} className={styles.slider__img} />
        </div>
        <div>
          <img src={SliderImg3} className={styles.slider__img} />
        </div>
      </Carousel>
    </div>
  );
};

export default LeftSideSlider;
